module.exports = __webpack_public_path__ + "img/aaa-solar.e3e92cae.webp";